import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import useInventoryTransactions from "src/hooks/context/useInventoryTransactions";
import InventoryTransactionsSummary from "../../Shared/InventoryTransactionsSummary";

type InventoryTransactionsModalProps = {
  open: boolean;
  onClose: () => void;
  sku: string;
  locationId: number;
};

export const InventoryTransactionsModal: React.FC<InventoryTransactionsModalProps> = ({
  open,
  onClose,
  sku,
  locationId,
}) => {
  const { isLoading, data, error } = useInventoryTransactions(sku, locationId, false);

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ paddingY: "0" }}>
        <Box sx={{ display: "flex", justifyContent: "flex-end", position: "relative" }}>
          <IconButton onClick={onClose} aria-label="close" size="large" sx={{ position: "relative", zIndex: 1 }}>
            <CloseIcon sx={{ fontSize: 28 }} />
          </IconButton>
        </Box>
        <Box sx={{ fontWeight: 700, fontSize: 20, textAlign: "left" }}>Recent transaction</Box>
      </DialogTitle>
      <DialogContent style={{ paddingTop: 34 }}>
        <InventoryTransactionsSummary data={data} isMobile={true} isLoading={isLoading} error={error} />
      </DialogContent>
      <DialogActions sx={{ pr: 3, pb: 2 }}>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#000",
            color: "#fff",
            fontWeight: 700,
            borderRadius: 1,
            px: 4,
            py: 1,
            fontSize: "16px",
            boxShadow: "none",
            "&:hover": { bgcolor: "#222" },
          }}
          onClick={onClose}
        >
          Okay
        </Button>
      </DialogActions>
    </Dialog>
  );
};
